// extracted by mini-css-extract-plugin
export var actionButton = "_da-0";
export var attachmentLine = "_da-1";
export var fileInput = "_da-2";
export var fileUploadWrapper = "_da-4";
export var footer = "_da-3";
export var modalContent = "_da-5";
export var paperclip = "_da-6";
export var quillEditor = "_da-7";